import SunEditor from "suneditor-react";
import "suneditor/dist/css/suneditor.min.css";
import { Control, useController } from "react-hook-form";

const ButtonCustomList = [
  ["undo", "redo"],
  ["font", "fontSize"],
  ["bold", "underline", "italic", "strike", "subscript", "superscript"],
  ["removeFormat"],
  ["fontColor", "hiliteColor"],
  ["outdent", "indent"],
  ["align", "horizontalRule", "list"],
  ["link"],
  ["fullScreen", "showBlocks", "codeView"],
];

type EditorProps = {
  control?: Control<any>;
  name?: string;
  defaultValue?: string;
  value?: string;
  onChange?: (value: string) => void;
  onBlur?: () => void;
  placeholder?: string;
  [key: string]: unknown;
};

type HookEditorProps = {
  control?: Control<any>;
  name: string;
  defaultValue?: string;
  placeholder?: string;
  [key: string]: unknown;
};

const HookEditor = ({
  control,
  name,
  defaultValue,
  ...props
}: HookEditorProps) => {
  const { field } = useController({
    name,
    control,
    rules: { required: true },
    defaultValue: defaultValue || "",
  });

  return (
    <SunEditor
      {...props}
      name={field.name}
      onBlur={field.onBlur}
      onChange={field.onChange}
      setContents={field.value || ""}
      setOptions={{
        height: "200",
        buttonList: ButtonCustomList,
        mode: "balloon",
      }}
    />
  );
};

const Editor = ({
  control,
  name,
  defaultValue,
  value,
  onChange,
  onBlur,
  ...props
}: EditorProps) => {
  const isControlled = value !== undefined || onChange !== undefined;

  if (isControlled) {
    return (
      <SunEditor
        {...props}
        name={name}
        onBlur={onBlur}
        onChange={onChange}
        setContents={value || ""}
        setOptions={{
          height: "200",
          buttonList: ButtonCustomList,
          mode: "balloon",
        }}
      />
    );
  }

  if (!name) {
    return null;
  }

  return (
    <HookEditor
      {...props}
      control={control}
      name={name}
      defaultValue={defaultValue}
    />
  );
};

export default Editor;
